import $ from 'jquery';
import './app.js';

window.jQuery = window.$ = $;

$(function() {
    let home_show_count = 0;
    let home_show_timer;
    //time in seconds
    let home_show_time_dialog = 240;
    let home_show_time_redirect = 300;
    let no_dialog_redirect = 240;
    if(location.pathname.split('/').slice(-1)[0] = "/") {
        // Set the initial index
        let currentIndex = 0;

        // Function to show the next image
        function showNextImage() {
            // Hide all images
            $('.wrapper .ss_slide').addClass('hidden');

            // Show the current image
            $('.wrapper .ss_slide').eq(currentIndex).removeClass('hidden');

            // Increment the index for the next iteration
            currentIndex = (currentIndex + 1) % $('.wrapper .ss_slide').length;

            // Use fadeIn() for a smooth transition
            $('.wrapper .ss_slide:not(.hidden)').fadeIn(1000);
        }

        showNextImage();
        
        // Set an interval to call the showNextImage function every (30 seconds)
        setInterval(showNextImage, 30000);
        home_show_restart();
    }

    // RESULTS PAGE - TIME COURSE MODALS
    if($("#time-course")) {
        $("#time-course img").on("click", function(){
            $("#modal-"+this.id).show();
            $(".overlay").addClass("active").show();
        });
    }

    // MOA PAGE
    if($("#moa-content")) {
        $("#moa-buttons div").on("click", function(){
            var moa_id = this.id.split("-").at(-1);
            $("#moa-content > img").hide();
            $("#moa-"+moa_id).show();
        })
    }

    if($(".sidebar")) {
        $(".sidebar li").on("click", function() {
            $(".sidebar li").removeClass("active");
            $(this).addClass("active");
            let image = $(this).data("nav");
            $(`img.body-image`).hide();
        });
    }

    $(".expand").on("click", function(){
        $(".overlay,.modal").hide();
        $(this).hide();
        $(".isi").addClass("expanded");
        $(".overlay").addClass("active").show();
        $(".close").show();
    });

    $(".close, .overlay").on("click", function() {
        $(this).hide();
        $(".isi").removeClass("expanded");
        $(".overlay").removeClass("active").hide();
        $(".expand").show();
        home_show_restart();
    });

    $("li[data-modal]").on("click", function () {
        const modalKey = $(this).data("modal").toUpperCase(); // this line is key
        console.log("modal", modalKey);
    
        $(".overlay").toggle();
    
        const $modal = $(".modal#" + modalKey);
    
        if ($modal.length) {
            console.log("Found modal:", $modal);
            $modal.show();
        } else {
            $("#REFERENCES").show();
            console.log("No matching modal found for ID:", modalKey);
        }
    });

    $("a[data-modal]").on("click", function () {
        const modalKey = $(this).data("modal").toUpperCase(); // this line is key
        console.log("modal", modalKey);
    
        $(".overlay").toggle();
    
        const $modal = $(".modal#" + modalKey);
    
        if ($modal.length) {
            console.log("Found modal:", $modal);
            $modal.show();
        } else {
            console.log("No matching modal found for ID:", modalKey);
        }
    });

    $("div[data-modal]").on("click", function() {
        var modalId = $(this).attr("id");
        console.log('modal', modalId);
        $(".overlay").toggle();

        var $modal = $(".modal#patient" + modalId);
    
        if ($modal.length) {
            console.log("Found modal:", $modal);
            $modal.show();
        } else {
            console.log("No matching modal found for ID:", modalId);
        }
    });

    if(".modal") {
        $(".modal").each(function() {
            $(this).prepend(`<img src="assets/img/modal/close.svg" alt="close" class="close-modal" />`);
        });

        $(".close-modal").on("click", function() {
            $(this).parent().hide();
            $(".overlay").hide();
        });

        $(".overlay").on("click", function() {
            $(".modal").hide();
            $(".overlay").hide();
        });

        $(".close-in-modal").on("click", function() {
            home_show_restart();
            $("#timeout").hide();
            $(".overlay").hide();
            $(".modal").hide();
        });
    }

    function home_show_create(){
        home_show_timer = setInterval(home_show_interval, 1000);
    }
    
    function home_show_interval(){
        home_show_count += 1;
        var path = location.pathname.split('/').slice(-1)[0];
        // console.log("the path is:", path)
        switch(path) {
            case "home.html":
                console.log("Redirect after 4 mins - No modal");
                if (home_show_count > no_dialog_redirect) {
                    window.location.href = "./index.html"
                }
                break;
            case "":
                console.log("Do nothing");
                // do nothing
                break;
            case "/":
                console.log("Do nothing");
                // do nothing
                break;
            case "/index":
                console.log("Do nothing");
                // do nothing
                break;
            case "index.html":
                console.log("Do nothing");
                // do nothing
                break;
            default:
                // console.log("Redirect after 5 mins - with modal");
                if ( home_show_count >= home_show_time_dialog && home_show_count < home_show_time_redirect ) {
                    $(".modal").hide();
                    $(".overlay").show();
                    $("#timeout").show();
                }
                if ( home_show_count >= home_show_time_redirect ) {
                    home_show_count = 0;
                    $(".overlay").hide();
                    $("#timeout").hide();
                    window.location.href = "./index.html"
                }
                break;
        }
    }
    
    function home_show_delete(){
        home_show_count = 0;
        clearInterval(home_show_timer);
    }
    
    function home_show_restart(){
        home_show_delete();
        home_show_count = 0;
        home_show_create();
    }

    // Study Design for PRODROME
    function openStudyDesignModal(){
        $(".overlay").toggle();
        $("#"+this.dataset.sd).show();
    }
    $('[data-sd]').on("click", openStudyDesignModal);
});



